/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ShopSparkleIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB3UlEQVR4nNWUTUsbYRCAtyLVQ0Uq6Mle+xfEU66BZD4WfJ1JK4gHW3r3nkMPTf0C8eIf0YsXQURLQ/UQeyu9tFQoFIq2AW2bMombbLK7msXk4MDAMu/MPPPFel4PxDn3CFjKpvbt9VqQdRFZa6bA8iLZEXUKSQ+B5LIeQLJvdmA9aCYgPc86Nx7EZObnh4H1tAXQ02w2OxRJ7vtzE8jyM3AM1GtUGLYtNorBEasWSD92xiBLpd4V4kgTkCdZijpqBJDLPXvc6EqO4/zDCiwfmgBg3e0G4JwbSw0oFosDQPq7GwCwvApGZGMIzz+8BxtfeEQPkPVXBED6rQGQ76H5XiDqTNuS2/YgldglA8tWzLJWrztYibzh7EIQS1R42XkEEbFKkHQTWX5Y5ZbcbPW3TGYQSJeR5exa35qtdd71iyoj6Unb5dwmRAUA1s/oay7uDUk+5bkw3XVCJNmzLoBkA1jedyz3CEjXgGUdSN619iRVIHnNLE+dc6PAkk8G3HJ22IXaX6CvAGS9Sg0Alm3ffz4Z+Nk3ku7Ed6B/UgP8UPJAiORJwoj+pgZ4Kfz7DkDWf/0G1BIBwPK1B4AvN3VQuvsO9E0iwDn30CBtnZBUEwEk1dApW0zJciQC7qX8B3IGNJlEm94JAAAAAElFTkSuQmCC)
 */
export const ShopSparkleIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        d="M20.14.8a1.21 1.21 0 0 0-2.28 0l-.5 1.37a2 2 0 0 1-1.19 1.18l-1.38.51a1.21 1.21 0 0 0 0 2.28l1.38.5a2 2 0 0 1 1.18 1.19l.51 1.38a1.2 1.2 0 0 0 1.15.79l.17-.01c.4-.06.79-.32.96-.78l.5-1.38a2 2 0 0 1 1.19-1.18l1.38-.51a1.21 1.21 0 0 0 0-2.28l-1.38-.5a2 2 0 0 1-1.18-1.19L20.14.79ZM20.98 11.84c0-.2-.24-.33-.42-.22-1.79 1.01-3.6-.17-4.87-1.55a.28.28 0 0 0-.4 0 4.49 4.49 0 0 1-6.58 0 .28.28 0 0 0-.4 0 4.45 4.45 0 0 1-4.94 1.11c-.17-.07-.37.06-.37.24V19a3 3 0 0 0 3 3h2.75c.14 0 .25-.11.25-.25V16c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2v5.75c0 .14.11.25.25.25H18a3 3 0 0 0 3-3l-.02-7.16Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
      <path
        d="M12.98 2c.22 0 .32.4.15.54a3.22 3.22 0 0 0 .97 5.47l.12.05c.28.1.4.42.24.65A3 3 0 0 1 9 7V3a1 1 0 0 1 1-1h2.98ZM2.63 4.19A3 3 0 0 1 5.53 2H7a1 1 0 0 1 1 1v4.03A2.95 2.95 0 0 1 5.03 10h-.05c-2 0-3.44-1.9-2.9-3.83l.55-1.98Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
    </svg>
  );
};
